import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { ClientType } from 'state/secondaryMarket/shared/form.models';
import type { Form } from 'state/secondaryMarket/shared/form/form.model';
import type { ChangeTrackForm } from 'state/secondaryMarket/shared/form/input/input.model';
import type { Collection } from 'state/utils/types';

export interface LiveForm extends Form {
  hasUpfrontFee?: boolean;
  tradingPrice?: number;
  traceReporting?: boolean;
  settlementPrice?: number;
  customizedUpfront?: number;
  customizedXMarginAdjustment?: number;
  customizedTradingPriceAdjustment?: number;
}

export type SecondaryMarketLiveFormTabContent = Omit<LiveForm, 'client'> & {
  bcsProductKey: string;
  client?: ISalesCounterpart;
  clientType: ClientType;
};

export type LiveFormField = keyof LiveForm;
export type LiveFormMap = Collection<LiveInputForm>;

export type LiveInputForm = ChangeTrackForm<LiveForm>;
export const initialLiveFormMap: LiveFormMap = {};
export const initialLiveForm: LiveInputForm = {
  tradeSizeInputMode: undefined,
  changes: [],
};
